import _ from 'underscore';

export const Keyword = {
  parent: 'AdGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Keyword',
    },
    Text: {
      'bulk-upload-header': 'Keyword',
    },
    MatchType: {
      'bulk-upload-header': 'Match Type',
      isReadOnly: true,
    },
    Bid: {
      bulkDeleteValueIfEmpty: true,
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    Param1: {
      bulkDeleteValueIfEmpty: true,
    },
    Param2: {
      bulkDeleteValueIfEmpty: true,
    },
    Param3: {
      bulkDeleteValueIfEmpty: true,
    },
    DestinationUrl: {
      'bulk-upload-header': 'Destination Url',
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
      bulkDeleteValueIfEmpty: true,
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        if (_.isArray(value)) {
          return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
        }
        return value;
      },
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      filterable: true,
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    // Enables Parent ID for asset-group-scoped keywords (UC flow).
    AssetGroup: {
      type: 'object',
      schema: { name: 'AssetGroup', properties: { Id: {} } },
    },
  },
};
